module.exports = __webpack_public_path__ + "annualreview2018/static/img/people@2x.25562db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/covers/people@2x.png
// module id = gf56
// module chunks = 10